import { createTheme, ThemeOptions } from "@mui/material";

const muiTheme: ThemeOptions = createTheme({
  palette: {
    success: {
      main: "#22BB33",
      light: "#81c784",
      dark: "#388e3c",
      contrastText: "#fff",
    },
    warning: {
      main: "#F0AD4E",
      light: "#ffb74d",
      dark: "#f57c00",
      contrastText: "#fff",
    },
  },
  typography: {
    body1: {
      fontSize: 16,
    },
    h1: {
      fontSize: 24,
      fontWeight: "bold",
      fontFamily: '"Literata", serif',
    },
    h2: {
      fontSize: 20,
      fontWeight: "bold",
      fontFamily: '"Literata", serif',
    },
    h3: {
      fontSize: 18,
    },
  },
});

export default muiTheme;